import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, ExternalLink, Heart } from 'lucide-react';
interface ProjectCardProps {
  title: string;
  description: string;
  category: string;
  thumbnailColor: string;
  likes: number;
  index: number;
  link: string;
}
export function ProjectCard({
  title,
  description,
  category,
  thumbnailColor,
  likes,
  link,
  index
}: ProjectCardProps) {
  return <motion.a href={link} target="_blank" rel="noopener noreferrer" initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    delay: index * 0.05,
    duration: 0.5
  }} className="group flex items-center gap-4 md:gap-6 p-4 md:p-6 rounded-2xl hover:bg-neutral-50 transition-colors cursor-pointer border border-transparent hover:border-neutral-100 no-underline" data-id="element-124">
      {/* Thumbnail */}
      <div className={`w-12 h-12 md:w-16 md:h-16 rounded-lg ${thumbnailColor} flex-shrink-0 flex items-center justify-center text-white font-bold text-xl shadow-sm`} data-id="element-125">
        {title.charAt(0)}
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0" data-id="element-126">
        <div className="flex items-center gap-2 mb-1" data-id="element-127">
          <h3 className="text-base md:text-lg font-semibold text-neutral-900 truncate" data-id="element-128">
            {title}
          </h3>
          <span className="hidden sm:inline-block px-2 py-0.5 rounded-full bg-neutral-100 text-neutral-500 text-xs font-medium" data-id="element-129">
            {category}
          </span>
        </div>
        <p className="text-sm md:text-base text-neutral-500 truncate pr-4" data-id="element-130">
          {description}
        </p>
        <span className="sm:hidden inline-block mt-2 px-2 py-0.5 rounded-full bg-neutral-100 text-neutral-500 text-xs font-medium" data-id="element-131">
          {category}
        </span>
      </div>

      {/* Arrow indicator */}
      <div className="flex items-center gap-3 md:gap-6" data-id="element-132">
        <div className="flex items-center justify-center w-10 h-10 rounded-full border border-neutral-200 text-neutral-400 group-hover:text-neutral-900 group-hover:border-neutral-900 transition-all" data-id="element-133">
          <ExternalLink className="w-4 h-4" data-id="element-134" />
        </div>
      </div>
    </motion.a>;
}